<template>
  <v-select :options="internalOptions"
            :clearable="false"
            :filterable="false"
            :searchable="false"
            :multiple="multiple"
            :value="getValue()"
            :placeholder="placeholder"
            :disabled="isDisabled"
            @input="onChange">
  </v-select>
</template>

<script>
  import Vue from "vue";

  export default Vue.extend({
    data() {
      return {
        selectedOption: null
      }
    },

    props: {
      options: {
        type: Array,
        required: true
      },
      multiple: {
        type: Boolean
      },
      addEmpty: {
        type: Boolean,
        required: false,
        default: false
      },
      placeholder: {
        type: String
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      selectedValue: {
        type: Number,
        default: 0
      }
    },

    mounted() {
      this.setDefaultValue(this.internalOptions[this.selectedValue]);
    },

    methods: {
      onChange(value) {
        this.selectedOption = value;
        this.$emit('input', this.selectedOption);
      },

      getValue() {
        return this.selectedOption?.label || '';
      },

      setDefaultValue(value) {
        this.selectedOption = value;
        this.$emit('input', this.selectedOption);
      }
    },

    computed: {
      internalOptions() {
        let options = this.options;

        if (this.addEmpty) {
          options = [{ text: "Any", value: "" }, ...options];
        }

        return options.map(option => ({
          label: option.text,
          value: option.value
        }));
      },

      isDisabled() {
        if (this.internalOptions.length <= 1)
          return true;

        return this.disabled;
      }
    }
  });
</script>
